/** Small shared translations (#799). */
import { t } from './i18n';

/** Env name ("testnet" | "mainnet") as a word inside a sentence; anything else unchanged. */
export function networkWord(name: string): string {
  if (name === 'testnet') return t('common.network.testnet');
  if (name === 'mainnet') return t('common.network.mainnet');
  return name;
}

/** Health banner / ticket text for a Hyperliquid health status (hl/health.ts healthMessage, translated). */
export function healthText(status: 'ok' | 'degraded' | 'down', network: string): string | null {
  if (status === 'degraded') return t('shell.health.degraded', { network: networkWord(network) });
  if (status === 'down') return t('shell.health.down', { network: networkWord(network) });
  return null;
}
